import { render, staticRenderFns } from "./OptionsMenu.vue?vue&type=template&id=10158d84&scoped=true&"
import script from "./OptionsMenu.vue?vue&type=script&lang=js&"
export * from "./OptionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./OptionsMenu.vue?vue&type=style&index=0&id=10158d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10158d84",
  null
  
)

export default component.exports